export default __webpack_public_path__ + "static/media/fusao.5a75f906.png";